<template>
	<Message :message="props.message">
		<div v-html="messageText"></div>
		<div
			v-if="props.message.messageData?.attachments"
			class="mt-3 flex flex-col gap-1"
		>
			<Media
				v-for="attachment in props.message.messageData.attachments"
				:key="attachment.fileIdent"
				:attachment="attachment"
			></Media>
		</div>
	</Message>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()

import { wrapSubstrings } from '@/services/markText'
import type { ResultRange } from '@/types/Search'
import type { Props } from '@/types/Message'
const props = defineProps<Props>()

import Message from '../Message.vue'
import Media from '../Media.vue'

const messageText = computed<string>(() => {
	// get search occurances with this message index from pre-computed map
	const messageInSearchResults =
		chatStore.searchChannelMessagesResultItemsByMessageIndex[
			props.message.messageIndex
		] ?? []

	if (!messageInSearchResults.length) {
		// message is not in search results, just return message text
		return props.message.messageText
	}

	// search item with active step
	const searchActiveItem =
		chatStore.searchChannelMessagesResultItemsFlat[
			chatStore.searchChannelMessagesCurrentSearchStep - 1
		]

	// get occurances within the message and highlight them
	const occurances = messageInSearchResults.map((occurance) => {
		return {
			start: occurance.stringStartIndex,
			end: occurance.stringEndIndex,
			active:
				occurance.messageIndex === searchActiveItem?.messageIndex &&
				occurance.stringStartIndex === searchActiveItem?.stringStartIndex &&
				occurance.stringEndIndex === searchActiveItem.stringEndIndex
		}
	})

	return wrapSubstrings(props.message.messageText, occurances)
})
</script>

<style scoped></style>
